import { AxiosResponse } from 'axios'

const donwloadFileWithAxiosResponse = (response: AxiosResponse<any, any>) => {
  const fileName = response.headers['content-disposition'].split('filename=')[1].replace(/"/g, '').trim()
  const href = URL.createObjectURL(response.data)

  const link = document.createElement('a')
  link.href = href
  link.setAttribute('download', fileName)
  document.body.appendChild(link)
  link.click()

  document.body.removeChild(link)
  URL.revokeObjectURL(href)
}

export default donwloadFileWithAxiosResponse
